import React from 'react';
import { Link } from 'react-router-dom';
import { BotIcon, ArrowRightIcon, ZapIcon } from 'lucide-react';
export function PlatformAgentsPage() {
  return <div className="w-full" data-id="element-7461">
      {/* Hero */}
      <section className="bg-gradient-to-br from-green-900 via-green-800 to-teal-900 text-white py-24" data-id="element-7462">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7463">
          <div className="max-w-3xl" data-id="element-7464">
            <h1 className="text-5xl font-bold mb-6" data-id="element-7465">Copilot Agents</h1>
            <p className="text-xl text-green-100 mb-8" data-id="element-7466">
              AI agents that automate your GTM tasks and workflows. From buying
              group insights to personalized outreach.
            </p>
            <div className="flex items-center gap-4" data-id="element-7467">
              <Link to="/" className="px-6 py-3 bg-white text-green-900 rounded-lg hover:bg-green-50 font-medium" data-id="element-7468">
                Try Copilot
              </Link>
              <Link to="/website/contact" className="px-6 py-3 border border-white text-white rounded-lg hover:bg-white/10 font-medium" data-id="element-7469">
                Request Demo
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* Features */}
      <section className="py-20 bg-white" data-id="element-7470">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7471">
          <div className="text-center mb-16" data-id="element-7472">
            <h2 className="text-3xl font-bold text-gray-900" data-id="element-7473">
              Agent Capabilities
            </h2>
            <p className="text-lg text-gray-600 mt-4" data-id="element-7474">
              Powerful AI agents that transform your GTM execution
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-7475">
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-7476">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4" data-id="element-7477">
                <BotIcon className="w-6 h-6 text-green-600" data-id="element-7478" />
              </div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-7479">
                Account Intelligence
              </h3>
              <p className="text-gray-600" data-id="element-7480">
                Get AI-generated summaries of accounts with key buying signals
                highlighted.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-7481">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4" data-id="element-7482">
                <ZapIcon className="w-6 h-6 text-green-600" data-id="element-7483" />
              </div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-7484">Automated Outreach</h3>
              <p className="text-gray-600" data-id="element-7485">
                Let AI craft personalized outreach based on account context and
                history.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-7486">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4" data-id="element-7487">
                <BotIcon className="w-6 h-6 text-green-600" data-id="element-7488" />
              </div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-7489">Next-Best Actions</h3>
              <p className="text-gray-600" data-id="element-7490">
                AI recommends the best next steps for each account in your
                pipeline.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* CTA */}
      <section className="py-16 bg-green-50" data-id="element-7491">
        <div className="max-w-5xl mx-auto px-6 text-center" data-id="element-7492">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-7493">
            Ready to automate your GTM?
          </h2>
          <p className="text-lg text-gray-600 mb-8" data-id="element-7494">
            Get started with Copilot Agents and transform your team's
            productivity
          </p>
          <Link to="/" className="px-8 py-4 bg-green-600 text-white rounded-lg hover:bg-green-700 font-medium inline-flex items-center gap-2" data-id="element-7495">
            Try Copilot
            <ArrowRightIcon className="w-5 h-5" data-id="element-7496" />
          </Link>
        </div>
      </section>
    </div>;
}